var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIconYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0932 6.62955L9.50521 3.04158M9.50521 3.04158L5.91724 6.62955M9.50521 3.04158L9.50521 11.6527M3.04687 11.6527L3.04687 12.5138C3.04687 13.7195 3.04687 14.3223 3.28151 14.7828C3.48791 15.1879 3.81724 15.5172 4.22231 15.7236C4.68282 15.9583 5.28565 15.9583 6.49132 15.9583L12.5191 15.9583C13.7248 15.9583 14.3276 15.9583 14.7881 15.7236C15.1932 15.5172 15.5225 15.1879 15.7289 14.7828C15.9635 14.3223 15.9635 13.7195 15.9635 12.5138L15.9635 11.6527",
    stroke: "#ffc42e",
    strokeWidth: 1.43519,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconYellow);
export default __webpack_public_path__ + "static/media/upload-icon-yellow.3678836ae553a8b23aeb377b3b0f12b2.svg";
export { ForwardRef as ReactComponent };